import PropTypes from 'prop-types';
import React from 'react';
import _ from 'lodash';

import { translate as t } from '../../lib/I18n';
import OrderStore from '../../stores/OrderStore';
import OrderActions from '../../actions/OrderActions';
import ModalActions from '../../actions/ModalActions';
import { GlobalModals, CheckoutStages } from '../../constants/AppConstants';
import urls from '../../urls';

import BaseModal from '../general/BaseModal';
import PureRenderComponent from '../PureRenderComponent';

class OrderStateErrorModal extends PureRenderComponent {

    static propTypes = {
        router: PropTypes.any.isRequired
    };

    state = {
        loading: true
    };

    UNSAFE_componentWillMount () {
        _.defer(() => {
            const order = OrderStore.getCurrent();
            OrderActions.refresh(order).then(() => {
                this.setState({ loading: false });
            });
        });
    }

    _closeModal () {
        ModalActions.close(GlobalModals.ORDER_STATE_ERROR);
    }

    _clearBasket = () => {
        OrderActions.clearBasket(OrderStore.getCurrent());
        this._closeModal();
    };

    _goToConfirmation = () => {
        this.props.router.push(urls.location(CheckoutStages.PAYMENT_CONFIRMATION));
        this._closeModal();
    };

    render () {
        return (
            <BaseModal className="modal--sm"
                    titleText="order.invalidStateModal.heading"
                    onClose={ this._clearBasket }
                    onContinue={ this._goToConfirmation }
                    continueText="order.invalidStateModal.paymentConfirmation"
                    closeText="order.invalidStateModal.planJourney"
                    disableContinue={ this.props.loading }>
                <div className="vertical-align-parent full-height">
                    <div className="confirmation margin-top margin-bottom vertical-align text-center">
                        <p>{ t('order.invalidStateModal.message') }</p>
                    </div>
                </div>
            </BaseModal>
        );
    }
}

export default OrderStateErrorModal;



// WEBPACK FOOTER //
// ./src/components/checkout/OrderStateErrorModal.js